import {
  collection,
  doc,
  getDocs,
  setDoc,
  deleteDoc,
  query,
  where,
  onSnapshot
} from 'firebase/firestore';
import { db } from '../firebase';

const SAVED_COLLECTION = 'savedExperiences';

export async function getSavedIds(userId) {
  if (!userId) return [];
  const q = query(
    collection(db, SAVED_COLLECTION),
    where('userId', '==', userId)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(d => d.data().experienceId);
}

export function subscribeToSaved(userId, callback) {
  if (!userId) {
    callback([]);
    return () => {};
  }
  const q = query(
    collection(db, SAVED_COLLECTION),
    where('userId', '==', userId)
  );
  const unsubscribe = onSnapshot(q, (snapshot) => {
    const ids = snapshot.docs.map(d => d.data().experienceId);
    callback(ids);
  });
  return unsubscribe;
}

export async function saveExperience(userId, experienceId) {
  if (!userId || !experienceId) return;
  const id = `${userId}_${experienceId}`;
  await setDoc(doc(db, SAVED_COLLECTION, id), {
    userId,
    experienceId,
    savedAt: new Date().toISOString()
  });
}

export async function unsaveExperience(userId, experienceId) {
  if (!userId || !experienceId) return;
  const id = `${userId}_${experienceId}`;
  await deleteDoc(doc(db, SAVED_COLLECTION, id));
}
